module.exports = __webpack_public_path__ + "static/media/why2.96d6e3f7.png";